/* eslint-disable matrix-org/require-copyright-header */

function injectDiv() {
    const matrixChat = document.querySelector(".mx_MatrixChat_wrapper");

    if (matrixChat && !document.getElementById("archer-custom-div")) {
        const wrapper = document.createElement("div");
        wrapper.id = "archer-custom-div";

        wrapper.innerHTML = `
            <section style="display: flex; flex-direction: row; gap: 20px; align-items: center; background:#3F4358; color:white; padding:10px;">
                <div class="logo-archer"></div>
                <h2 style="color: white !important; font-family: Inter; font-size: 28px; font-weight: 600;">
                    L'Archer Chat
                </h2>
            </section>
        `;

        matrixChat.prepend(wrapper);
    }
}


const observer = new MutationObserver(() => {
    injectDiv();
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});